import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { ManagementGroupsConfigService } from './shared/management-groups.config.service';
import { Logger, AuthenticationService } from '@app/core';
import { GroupsPermissionsDataService } from '../shared/groups-permissions.data.service';
import {
  Rol,
  ConfirmComponent,
  RolDefault,
  Const,
} from '@app/shared';
import { ManagementGroupsDataService } from './shared/management-groups.data.service';
import { ManagementGroupsFormsService } from './shared/management-groups.form.service';
import { BaseControl } from '../../../shared/dynamic-form/shared/controls/base-control';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

const log = new Logger('ManagementGroupsComponent');

@Component({
  selector: 'iw-management-groups',
  templateUrl: './management-groups.component.html',
  styleUrls: ['./management-groups.component.scss'],
  providers: [
    GroupsPermissionsDataService,
    ManagementGroupsDataService,
    ManagementGroupsFormsService
  ]
})
export class ManagementGroupsComponent implements OnInit, OnDestroy {

  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define si el rol en accion es para editar o agregar
  rolEdit = true;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
  };
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Contiene el rol seleccionado
  rolSelect: Rol;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;

  constructor(
    private gpds: GroupsPermissionsDataService,
    private mgds: ManagementGroupsDataService,
    private mgfs: ManagementGroupsFormsService,
    private as: AuthenticationService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesions
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.review,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.update,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.delete,
    );
    const configTable = new ManagementGroupsConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });
    this.loadingRoles();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga los roles(Grupos) del sistema
   *
   * @memberof ManagementGroupsComponent
   */
  loadingRoles() {
    if (this.activateAction.review) {
      this.gpds.getRoles().subscribe(roles => this.sourceData = new LocalDataSource(roles));
    } else {
      this.toastr.error('Usted no posee permisos para ver los grupos del sistema', 'Permiso denegado');
    }
  }

  /**
   * Controla las diferentes acciones de agregar, modificar o eliminar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ManagementGroupsComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        if (this.activateAction.created) {
          this.formOpen = true;
          this.rolEdit = false;
          this.actionForm = 'Agregar';
          this.controls = this.mgfs.getFormRol();
        } else {
          this.toastr.error('Usted no posee permisos para agregar grupos en el sistema', 'Permiso denegado');
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.rolEdit = true;
          this.actionForm = 'Modificar';
          this.rolSelect = data;
          this.controls = this.mgfs.getFormRol(this.rolSelect);
        } else {
          this.toastr.error('Usted no posee permisos para modificar grupos en el sistema', 'Permiso denegado');
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.rolSelect = data;
          this.question = '¿Realmente desea eliminar el grupo?';
          this.confirm.open();
        } else {
          this.toastr.error('Usted no posee permisos para eliminar grupos en el sistema', 'Permiso denegado');
        }
        break;
    }
  }

  /**
   * Controla la accion de confimacion del modal
   *
   * @param {boolean} res
   * @memberof ManagementGroupsComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteRol();
    }
    this.question = '';
  }

  /**
   * Cierra la vista del formulario de creacion o edicion de un rol(Grupo)
   *
   * @memberof ManagementGroupsComponent
   */
  closeFormRol() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.rolEdit = false;
    this.rolSelect = null;
  }

  /**
   * Guarda o edita un rol(grupo) en el sistema
   *
   * @param {*} data
   * @memberof ManagementGroupsComponent
   */
  sended(data: any) {
    if (data) {
      let rol: RolDefault;
      rol = {
        nombre: data.txtNombre,
        descripcion: data.txtDescripcion,
        activo: data.chActivo,
        rol_empresa: this.as.getCredentials().info_persona.id_empresa,
        permisos: []
      };

      if (this.rolEdit) {
        this.mgds.updateRol(this.rolSelect.id, rol).then(() => {
          this.loadingRoles();
          this.closeFormRol();
        }).catch(() => {
          this.closeFormRol();
        });
      } else {
        this.mgds.addRol(rol).then(() => {
          this.loadingRoles();
          this.closeFormRol();
        }).catch(() => {
          this.closeFormRol();
        });
      }

    }
  }

  /**
   * Elimina un rol(grupo) del sistema
   *
   * @private
   * @memberof ManagementGroupsComponent
   */
  private deleteRol() {
    this.mgds.deleteRol(this.rolSelect.id).then(() => {
      this.loadingRoles();
      this.closeFormRol();
    }).catch(() => {
      this.closeFormRol();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-groups/management-groups.component.ts